import Vue from 'vue';
export default Vue.extend({
  name: 'LineageReport',
  props: {
    datos: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    class_main: {
      type: String,
      default: 'lineage-dataset'
    }
  },
  data: function data() {
    return {
      nodeWidth: 200,
      nodeHeight: 70,
      levelGap: 160,
      verticalGap: 50,
      marginX: 60,
      marginY: 40,
      svgWidth: 800,
      svgHeight: 400,
      rootNode: null,
      nodes: [],
      links: []
    };
  },
  created: function created() {
    ;
    this.buildTree();
  },
  methods: {
    iconName: function iconName(node) {
      var kind = this.nodeKind(node);
      if (kind === 'table') return 'storage'; // icono tipo tabla
      if (kind === 'connection') return 'grid_on'; // icono conexión
      return 'leaderboard'; // icono reporte / gráfico
    },
    buildTree: function buildTree() {
      var dataset = this.datos && this.datos.dataset ? this.datos.dataset : {};
      var tables = this.datos && this.datos.tables ? this.datos.tables : [];
      var root = {
        id: 'root-dataset',
        label: dataset.object_name || 'Reporte',
        secondary: dataset.type || dataset.object_owner || 'REPORT',
        depth: 0,
        children: [],
        x: 0,
        y: 0
      };
      tables.forEach(function (table) {
        var tableNode = {
          id: table.id || "table-".concat(table.name),
          label: table.name || 'Tabla',
          secondary: table.type || table.description || 'DATASOURCE',
          depth: 1,
          children: [],
          x: 0,
          y: 0
        };
        var conexiones = table.conexiones || [];
        conexiones.forEach(function (con, index) {
          var child = {
            id: "".concat(tableNode.id, "-conexion-").concat(index, "-").concat(con.name),
            label: con.name || 'Conexión',
            secondary: con.project_name || con.description || '',
            depth: 2,
            children: [],
            x: 0,
            y: 0
          };
          tableNode.children.push(child);
        });
        root.children.push(tableNode);
      });
      this.rootNode = root;
      this.assignPositions();
      this.flattenTree();
    },
    assignPositions: function assignPositions() {
      var _this = this;
      if (!this.rootNode) return;
      var leafIndex = 0;
      var nodeHeight = this.nodeHeight;
      var verticalGap = this.verticalGap;
      var marginY = this.marginY;
      var _setY = function setY(node) {
        if (!node.children || node.children.length === 0) {
          node.y = marginY + leafIndex * (nodeHeight + verticalGap) + nodeHeight / 2;
          leafIndex += 1;
        } else {
          node.children.forEach(function (child) {
            return _setY(child);
          });
          var first = node.children[0];
          var last = node.children[node.children.length - 1];
          node.y = (first.y + last.y) / 2;
        }
      };
      _setY(this.rootNode);
      var totalLeaves = leafIndex || 1;
      this.svgHeight = marginY * 2 + (totalLeaves - 1) * (nodeHeight + verticalGap) + nodeHeight;
      var depthNodes = {};
      var _collect = function collect(node) {
        if (!depthNodes[node.depth]) {
          depthNodes[node.depth] = [];
        }
        depthNodes[node.depth].push(node);
        node.children.forEach(function (child) {
          return _collect(child);
        });
      };
      _collect(this.rootNode);
      var depths = Object.keys(depthNodes).map(function (d) {
        return parseInt(d, 10);
      });
      var maxDepth = depths.length > 0 ? Math.max.apply(null, depths) : 0;
      this.svgWidth = this.marginX * 2 + (maxDepth + 1) * (this.nodeWidth + this.levelGap);
      var rootX = this.svgWidth - this.marginX - this.nodeWidth / 2;
      var _setX = function setX(node) {
        node.x = rootX - node.depth * (_this.nodeWidth + _this.levelGap);
        node.children.forEach(function (child) {
          return _setX(child);
        });
      };
      _setX(this.rootNode);
    },
    flattenTree: function flattenTree() {
      if (!this.rootNode) return;
      var nodes = [];
      var links = [];
      var _traverse = function traverse(node) {
        nodes.push(node);
        node.children.forEach(function (child) {
          links.push({
            id: "".concat(node.id, "__").concat(child.id),
            from: node,
            to: child
          });
          _traverse(child);
        });
      };
      _traverse(this.rootNode);
      this.nodes = nodes;
      this.links = links;
    },
    connectorPath: function connectorPath(link) {
      var parent = link.from;
      var child = link.to;
      var parentX = parent.x - this.nodeWidth / 2;
      var parentY = parent.y;
      var childX = child.x + this.nodeWidth / 2;
      var childY = child.y;
      var midX = (parentX + childX) / 2;
      return "M ".concat(parentX, " ").concat(parentY, " H ").concat(midX, " V ").concat(childY, " H ").concat(childX);
    },
    // --- node visual helpers ---
    nodeKind: function nodeKind(node) {
      if (node.depth === 0) return 'root';
      if (node.depth === 1) return 'table';
      return 'connection';
    },
    nodeColor: function nodeColor(node) {
      var kind = this.nodeKind(node);
      if (kind === 'table') return '#22C55E'; // verde
      if (kind === 'connection') return '#F97316'; // naranja
      return '#2563EB'; // azul
    },
    // ---- wrap en 2 líneas, soporta textos sin espacios ----
    wrapText: function wrapText(text, maxChars, maxLines) {
      if (!text) return [];
      var trimmed = text.trim();
      if (!trimmed) return [];
      var words = trimmed.split(/\s+/);
      // Caso especial: una sola "palabra" larga
      if (words.length === 1) {
        var raw = words[0];
        var chunks = [];
        for (var i = 0; i < raw.length && chunks.length < maxLines; i += maxChars) {
          chunks.push(raw.slice(i, i + maxChars));
        }
        if (raw.length > maxChars * maxLines) {
          var lastIndex = chunks.length - 1;
          var _last = chunks[lastIndex];
          if (_last.length > maxChars - 1) {
            _last = _last.slice(0, maxChars - 1);
          }
          chunks[lastIndex] = _last + '…';
        }
        return chunks;
      }
      // Caso normal: varias palabras
      var lines = [];
      var current = '';
      words.forEach(function (word) {
        var test = current ? "".concat(current, " ").concat(word) : word;
        if (test.length <= maxChars) {
          current = test;
        } else {
          if (current) lines.push(current);
          current = word;
        }
      });
      if (current) lines.push(current);
      if (lines.length <= maxLines) {
        return lines;
      }
      var limited = lines.slice(0, maxLines);
      var last = limited[maxLines - 1];
      if (lines.length > maxLines) {
        if (last.length > maxChars - 1) {
          last = last.slice(0, maxChars - 1);
        }
        limited[maxLines - 1] = last + '…';
      }
      return limited;
    },
    getTitleLines: function getTitleLines(label) {
      return this.wrapText(label, 18, 2);
    },
    getSecondaryLines: function getSecondaryLines(text) {
      return this.wrapText(text, 22, 2);
    }
  }
});